import {
  FormHelperText,
  Typography,
  FormControl,
  Input as _Input,
  InputProps,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {getValueFromNestedObject} from "../../../../utils/langUtils.ts";

const Input = styled(_Input)`
  padding: 0.4rem 0.7rem;
`;

type LoginFormInputProps = {
  name: string;
  label: string;
} & InputProps;

const LoginFormInput: FC<LoginFormInputProps> = ({
  name,
  label,
  ...otherProps
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = getValueFromNestedObject(errors, name)

  return (
    <Controller
      control={control}
      defaultValue=""
      name={name}
      render={({ field }) => (
        <FormControl fullWidth sx={{ mb: 2 }}>
          <Typography
            variant="body2"
            sx={{ mb: 1, fontWeight: 500 }}
          >
            {label}
          </Typography>
          <Input
            {...field}
            fullWidth
            sx={{ borderRadius: '1rem' }}
            error={!!error}
            {...otherProps}
          />
          <FormHelperText error={!!error}>
            {error ? (error?.message as unknown as string) : ''}
          </FormHelperText>
        </FormControl>
      )}
    />
  );
};

export default LoginFormInput;
